const moduleName = 'forms';

export function forms() {
    document.querySelectorAll('.switch-checkbox').forEach((input) => {
        input.addEventListener('change', function () {
            const price = parseInt(input.dataset.price);
            const feature = this.closest('.switch-feature');
            const checked = this.checked;
            if (price) {
                const priceEl = this.closest('.js-has-dynamic-price').querySelector('.js-dynamic-price');
                if (checked) {
                    priceEl.textContent = parseInt(priceEl.textContent) + price;
                } else {
                    priceEl.textContent = parseInt(priceEl.textContent) - price;
                }
            }
            if (feature) {
                feature.classList.toggle('disabled');
            }
        });
    });
}
